export const environment = {
  production: true,
  loginHost: 'https://login.stage.x-keeper.net',
  staticUrl: 'https://static.stage.x-keeper.net',
  downloadFilesUrl: '/download-files',
  apiUrl: '/api',
  api2Url: '/api2',
  xOutkeepSentryDsn:
    'https://d603dfddee44bc770d0c3139eea11b68@sentry.stage.x-keeper.net/10',
  xOutkeepInfrastructureEnv: 'stage',
  xOutkeepEnableLanguageChange: false,
  workflowsEnabled: false,
  warehouseIframeUrl: 'https://system.x-keeper.net/p/warehouse',
  accountingIframeUrl: 'https://accounting-frontend.stage.x-keeper.net',
  docflowIframeUrl:
    'https://system-mirror.stage.x-keeper.net/logistic/?embed=1#/docFlow',
  // docflowIframeUrl:
  //   'https://system-v1.stage.x-keeper.net/logistic/?embed=1#/docFlow',
};
